import * as React from "react";
import { HierarchyControl, HierarchyControlItem } from '../../../../basf-ui';
import { useDictionary, useParameter } from "../../../shared";
import { orderBy } from "lodash";
import { dictionaryService } from "../../../dataFlow";
import { SLIDE_NUMBER } from "../constants";

interface ControlItem extends HierarchyControlItem<number> {
    olapId: number;
}

const BUSINESS_UNIT = 1;
export const CommoditiesControl: React.FC = () => {
    const [items, setItems] = React.useState<ControlItem[]>([]);
    const [loadingValue, setLoadingValue] = React.useState<boolean>(true);

    const [displayCommodityId, setDisplayCommodityId] = useParameter<number | null>("@commodities_display");
    const [commodityId, setCommodityId] = useParameter<number | null>("@commodities");

    const [dictItems, _dict, loadingDict] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
        business_unit: BUSINESS_UNIT,
        slide: SLIDE_NUMBER,
    });

    React.useEffect(function updateControlItems() {
        setLoadingValue(true);
        if (dictItems) {
            const sortedDictItems = orderBy(dictItems, item => item.getValue<number>("order"));
            const nextControlItems = sortedDictItems.map<ControlItem>(dictItem => ({
                id: dictItem.getValue<number>('id')!,
                name: dictItem.getValue<Record<number, string>>("name")![9],
                parent: dictItem.getValue<number>("parent"),
                olapId: dictItem.getValue<number>('olap_commodity')!,
            }));
            setItems(nextControlItems);

            const selectedCandidate = nextControlItems.find(e => e.olapId === commodityId);
            if (selectedCandidate) {
                if (selectedCandidate.id !== displayCommodityId) {
                    setDisplayCommodityId(selectedCandidate.id);
                }
            } else {
                setDisplayCommodityId(nextControlItems[0]?.id);
            }
            setLoadingValue(false);
        }
    }, [dictItems, displayCommodityId, commodityId]);

    const handlerChange = React.useCallback((value: number) => {
        const selectedCandidate = items.find(e => e.id === value)!;
        setDisplayCommodityId(value);
        setCommodityId(selectedCandidate.olapId);
    }, [items]);

    const loading = loadingValue || loadingDict;

    const control = React.useMemo(() => {
        const label = "Commodities";
        return <HierarchyControl loading={loading} label={label} value={displayCommodityId!} items={items} onChange={handlerChange} />
    }, [displayCommodityId, items, loading, handlerChange]);

    return control;
};
